export const canReturnEmail = (loginProvider) => {
    return (loginProvider === 'email' ||
        loginProvider === 'google' ||
        loginProvider === 'apple' ||
        loginProvider === 'x');
};
//# sourceMappingURL=LoginProviderUtils.js.map